{
  "startup": {
    "loading": "Opening your data…",
    "errorTitle": "The app could not open its data",
    "errorBody": "Close the app completely and open it again. If you see this again, tell your office.",
    "errorDetails": "Technical details: {{message}}"
  },
  "welcome": {
    "purpose": "Prepare your vessel for the RISQ inspection: your questions, status, notes and photos. Works without internet.",
    "signIn": "Sign in",
    "signInHint": "Your office invites you first. Then you sign in once with your email address and a code."
  },
  "home": {
    "title": "Home",
    "settings": "Settings",
    "you": "You: {{position}}",
    "progressMine": "My questions: {{done}} of {{total}} done ({{percent}}%)",
    "progressVessel": "Whole vessel: {{done}} of {{total}} done ({{percent}}%)",
    "progressEngine": "Engine questions: {{done}} of {{total}} done ({{percent}}%)",
    "thisWeek": "This week ({{count}})",
    "doNow": "What to do now ({{count}})",
    "allMine": "All my questions",
    "allVessel": "All vessel questions",
    "allEngine": "All engine questions",
    "vesselProgress": "Vessel progress",
    "inspectionDate": "Inspection date",
    "showTitle": "Show",
    "showVessel": "Whole vessel",
    "showMine": "My questions",
    "showHint": "Only changes what you see. Your rights stay the same. In Whole vessel, engine room questions are at the bottom.",
    "pending_one": "{{count}} change saved on the phone, waiting to be sent",
    "pending_other": "{{count}} changes saved on the phone, waiting to be sent",
    "finalChecks": "Final checks ({{done}} of {{total}} done)",
    "finalChecksQuestions": "Final checks: questions for the last 24 hours ({{count}})",
    "crew": "Crew on board",
    "noVesselTitle": "No vessel on this phone",
    "noVesselBody": "Sign in to download the questions of your vessel.",
    "pendingPhotos_one": "{{count}} photo saved on the phone, waiting to be sent ({{size}} MB)",
    "pendingPhotos_other": "{{count}} photos saved on the phone, waiting to be sent ({{size}} MB)",
    "history": "History"
  },
  "settings": {
    "title": "Settings",
    "language": "Language",
    "textSizeTitle": "Text size",
    "textSizeBody": "To make the text larger, change the text size in your phone settings. Opti-Sea follows it.",
    "about": "About Opti-Sea",
    "account": "Signed in as {{email}}",
    "signOut": "Sign out",
    "deleteAccount": "Delete account",
    "signOutTitle": "Sign out?",
    "signOutBody": "The data of your vessel is removed from this phone. To use the app again, you sign in with your email and a new code (internet needed).",
    "signOutUnsent_one": "{{count}} change on this phone was not sent yet. It will be lost.",
    "signOutUnsent_other": "{{count}} changes on this phone were not sent yet. They will be lost.",
    "deleteTitle": "Delete your account?",
    "deleteBody": "Your Opti-Sea account and your access end. Your work stays in the vessel history as \"Former crew member\". This cannot be undone. Internet is needed.",
    "deleting": "Deleting your account…",
    "deleteFailed": "Your account was not deleted.",
    "signOutUnsentPhotos_one": "{{count}} photo on this phone was not sent yet. It will be lost.",
    "signOutUnsentPhotos_other": "{{count}} photos on this phone were not sent yet. They will be lost.",
    "mobileDataTitle": "Sync on mobile data",
    "mobileDataBody": "Ship Wi-Fi is the usual way. Mobile data can be expensive at sea and in roaming.",
    "wifiOnly": "Wi-Fi only",
    "wifiOnlyDetail": "Recommended. Your work waits on the phone until there is Wi-Fi.",
    "mobileData": "Wi-Fi and mobile data",
    "mobileDataDetail": "Changes and photos are also sent over mobile data.",
    "saved": "Saved on phone"
  },
  "about": {
    "title": "About",
    "version": "Version {{version}}",
    "purpose": "Opti-Sea helps the crew of bulk carriers prepare for the RISQ inspection."
  },
  "inspection": {
    "notSetTitle": "Inspection date not set",
    "notSetMaster": "Set the planned inspection date. Then the app shows what to do now.",
    "notSetOfficer": "The Master sets the planned inspection date. Then the app shows what to do now.",
    "planned": "Inspection: {{date}}",
    "daysLeft_one": "in {{count}} day",
    "daysLeft_other": "in {{count}} days",
    "today": "today",
    "passedTitle": "The planned date has passed",
    "passedBody": "The inspection was planned for {{date}}. The Master sets the next date.",
    "next": "Next: {{timing}} from {{date}}.",
    "phase": {
      "early": "Too early to start",
      "six_months": "Now: “6 months before”",
      "three_months": "Now: “3 months before”",
      "last": "Now: the last voyage",
      "final_24h": "Now: the last 24 hours",
      "passed": "Everything still open"
    },
    "phaseBody": {
      "early": "Questions marked “6 months before” start on {{date}}, 12 months before the inspection.",
      "six_months": "Work on questions marked “6 months before”. Finish them by {{finishBy}}.",
      "three_months": "Work on questions marked “3 months before”. Finish them by {{finishBy}}. Late questions come first.",
      "last": "Work on questions marked “Last voyage”. Late questions come first.",
      "final_24h": "Questions marked “Last 24 hours”, and everything still open.",
      "passed": "All questions with a preparation flag that are still open."
    },
    "editTitle": "Inspection date",
    "editBody": "Planned RISQ inspection of {{vessel}}. Everyone on board sees it. It decides what the app shows under \"What to do now\".",
    "invalid": "Choose a day from today up to two years ahead.",
    "preview": "When to prepare",
    "previewTiming": "{{timing}}: from {{start}}, finish by {{finishBy}}",
    "plannedWhen": "Inspection: {{date}} — {{when}}",
    "lastVoyageSince": "Last voyage since {{date}}.",
    "lastVoyageDefault": "The last voyage counts from 7 days before the inspection until the office records its start.",
    "dateLabel": "Planned inspection day",
    "dateEmpty": "No day chosen yet"
  },
  "due": {
    "now": "Now",
    "later": "Later — starts closer to the inspection",
    "late": "Late — finish it now"
  },
  "lists": {
    "mine": "My questions",
    "vessel": "Whole vessel",
    "engine": "Engine questions",
    "week": "This week",
    "now": "What to do now",
    "section": "Section {{code}}",
    "sectionProgress": "{{done}} of {{total}} done ({{percent}}%)",
    "count_one": "{{count}} question",
    "count_other": "{{count}} questions",
    "emptyWeek": "No questions of the week for you. The office chooses them.",
    "emptyNow": "Nothing to do now with the current filter.",
    "emptyNoDate": "The inspection date is not set, so the app cannot tell what to do now.",
    "empty": "No questions here with the current filter.",
    "filter": "Filter",
    "filterNone": "Filter: all questions",
    "filterActive": "Filter: {{list}}",
    "clearFilter": "Clear filter",
    "responsible": "Responsible: {{positions}}",
    "unassigned": "Nobody yet",
    "checkAgain": "Check again — question changed",
    "flags": "{{list}}",
    "engineGroup": "Engine room ({{count}})",
    "engineShow": "Show engine room questions ({{count}})",
    "engineHide": "Hide engine room questions",
    "timingsTitle": "What the time marks mean",
    "timingLine": "{{short}}: {{meaning}}."
  },
  "filters": {
    "title": "Filter questions",
    "workTypes": "Type of work",
    "timings": "When to prepare",
    "hint": "Choose one or more. A question is shown when it has one of the chosen marks.",
    "show_one": "Show {{count}} question",
    "show_other": "Show {{count}} questions",
    "clear": "Clear filter",
    "selected": "Selected",
    "notSelected": "Not selected"
  },
  "question": {
    "title": "Question {{code}}",
    "section": "Section {{code}}",
    "responsible": "Responsible",
    "sourceVessel": "Changed for this vessel",
    "sourceCompany": "Company setting",
    "sourceBase": "From the master file",
    "workTypes": "Type of work",
    "timings": "When to prepare",
    "noFlags": "No marks",
    "advice": "Advice",
    "lastNote": "Last note",
    "attention": "Changed by two people — check",
    "changeStatus": "Change status",
    "checklist": "What to check ({{checked}} of {{total}})",
    "checklistEmpty": "What to check",
    "addNote": "Add note",
    "guidance": "Inspector guidance",
    "reassign": "Reassign",
    "notFound": "Question not found",
    "notFoundBody": "This question is not on your phone any more. Go back to the list.",
    "timingDefault": "No time flag in the master file: counted as “3 months before”",
    "flagSourceCompany": "Marks set by your company",
    "timingLine": "{{short}} — {{meaning}}",
    "photos": "Photos ({{count}})"
  },
  "status": {
    "title": "Change status",
    "current": "Current",
    "hint": "Question {{code}}",
    "option": "{{icon}}  {{word}}",
    "tickFirst": "Tick all check points first ({{checked}} of {{total}} ticked). Tick a point also when it does not apply to your vessel."
  },
  "note": {
    "title": "Add note",
    "label": "Your note",
    "hint": "Question {{code}}. The note is saved with your name and position."
  },
  "checklist": {
    "title": "What to check",
    "progress": "{{checked}} of {{total}} ticked",
    "checked": "Checked",
    "notChecked": "Not checked",
    "companyPoint": "Company point",
    "empty": "This question has no check points yet.",
    "imsTitle": "Company IMS references",
    "imsHint": "From your company, not part of RISQ.",
    "notApplicable": "Tick a point also when it does not apply to your vessel. The question can be closed when every point is ticked."
  },
  "guidance": {
    "title": "Inspector guidance",
    "empty": "No inspector guidance for this question.",
    "sectionTitle": "About section {{code}}"
  },
  "history": {
    "title": "History",
    "empty": "Nothing has changed on the questions yet.",
    "status": "{{from}} → {{to}}",
    "statusFirst": "Status: {{to}}",
    "note": "Note: {{text}}",
    "checked": "Ticked: {{point}}",
    "unchecked": "Unticked: {{point}}",
    "pointGone": "a check point that was removed",
    "positionsSet": "Responsible: {{from}} → {{to}}",
    "positionsRevert": "Returned to the {{source}}: {{to}}",
    "layerVessel": "Changed for this vessel",
    "layerCompany": "Changed for the company",
    "sourceCompany": "company setting",
    "sourceBase": "master file",
    "by": "{{name}}, {{position}} · {{time}}",
    "byRole": "{{name}} ({{role}}) · {{time}}",
    "unknownPerson": "Someone",
    "roles": {
      "admin": "Admin",
      "dpa": "Office",
      "master": "Master",
      "service": "System"
    },
    "former": "Former crew member",
    "photoAdded": "Photo added",
    "photoRemoved": "Photo removed",
    "intro": "Changes to the questions of {{vessel}} on this phone, newest first. Tap a line to open the question.",
    "filterLabel": "Question number",
    "filterHint": "For example 4.5, or 8B for a whole section. Leave empty to see all.",
    "emptyFilter": "No changes for this question number.",
    "line": "{{code}} · {{change}}",
    "more": "Showing the latest {{count}} changes. Enter a question number to see older ones."
  },
  "reassign": {
    "title": "Reassign question",
    "now": "Question {{code}}. Responsible now: {{positions}}",
    "body": "Choose who is responsible on {{vessel}}. Only this vessel changes. The change is saved on the phone, sent to the office and kept in the history.",
    "current": "Now",
    "revertCompany": "Return to the company setting: {{positions}}",
    "revertBase": "Return to the master file: {{positions}}",
    "continue": "Continue",
    "confirmTitle": "Reassign {{code}}?",
    "confirmBody": "From {{from}} to {{to}} on {{vessel}}. The question leaves the list of {{from}} and appears in the list of {{to}}.",
    "confirm": "Reassign",
    "revertTitle": "Return {{code}}?",
    "revertBody": "Responsible on {{vessel}} again: {{to}} ({{source}}). The change for this vessel is removed; the history keeps it.",
    "revertConfirm": "Return"
  },
  "vesselProgress": {
    "title": "Vessel progress",
    "byPosition": "By position",
    "unassigned": "Not assigned to a position",
    "byPhase": "By preparation flag",
    "positionLine": "{{done}} done, {{left}} left",
    "phaseLine": "{{done}} of {{total}} done ({{percent}}%)",
    "phaseTitle": "{{short}} — {{meaning}}",
    "noQuestions": "No questions",
    "phaseHint": "Questions without a time flag count as “3 months before”."
  },
  "finalChecks": {
    "title": "Final checks",
    "inspection": "Inspection {{date}} ({{when}})",
    "today": "today",
    "tomorrow": "tomorrow",
    "progress": "{{done}} of {{total}} done ({{percent}}%)",
    "closedTitle": "Final checks are not open",
    "closedBody": "They open on {{date}}, the day before the planned inspection.",
    "noInspection": "The Master sets the planned inspection date first.",
    "intro": "The company's list for the last day. Tap an item when it is done. Ticks belong to the inspection on {{date}}; a new date starts a fresh list.",
    "noGroups": "Your position has no items in the company's list. Check your questions for the last 24 hours below.",
    "when": {
      "day_before": "1 day before",
      "hour_before": "1 hour before the deck inspection"
    },
    "tickedBy": "Ticked by: {{positions}}",
    "groupProgress": "{{done}} of {{total}} done",
    "done": "Done",
    "notDone": "Not done",
    "linked": "RISQ {{codes}}",
    "doneBy": "Done by {{position}} at {{time}}",
    "valueEmpty": "{{label}}: not entered",
    "valueSet": "{{label}}: {{value}}",
    "enterValue": "Enter",
    "questionsTitle": "RISQ questions for the last 24 hours",
    "questionsEmpty": "No questions for the last 24 hours in your list.",
    "valueTitle": "Final check",
    "valueSave": "Save",
    "valueClear": "Remove the entry",
    "valueText": "Text",
    "invalidDate": "Choose a day not later than today.",
    "invalidText": "Enter 1 to 200 characters.",
    "dateEmpty": "No day chosen yet"
  },
  "signIn": {
    "emailTitle": "Sign in",
    "emailBody": "Enter the email address your office gave for you. We send you a 6-digit code.",
    "emailLabel": "Email address",
    "emailInvalid": "Enter your full email address, for example name@example.com.",
    "sendCode": "Send code",
    "sending": "Sending the code…",
    "codeTitle": "Enter the code",
    "codeBody": "We sent a 6-digit code to {{email}}. It can take a few minutes. If you do not see it, look in the spam folder.",
    "codeLabel": "6-digit code",
    "codeInvalid": "The code has 6 digits.",
    "confirm": "Confirm",
    "checking": "Checking the code…",
    "sendAgain": "Send a new code",
    "sendAgainIn": "You can ask for a new code in {{seconds}} seconds.",
    "codeSent": "A new code is on its way.",
    "passwordLink": "Sign in with password (app review only)",
    "passwordTitle": "Sign in with password",
    "passwordBody": "Only for the test account given to app reviewers. Crew members sign in with the email code.",
    "passwordLabel": "Password",
    "passwordSignIn": "Sign in",
    "vesselTitle": "Choose your vessel",
    "vesselBody": "You have a position on more than one vessel. Choose the vessel for this phone.",
    "vesselPosition": "{{position}} since {{date}}",
    "choose": "Continue",
    "loadingVessels": "Looking for your vessel…",
    "noVesselTitle": "No vessel yet",
    "noVesselBody": "You are signed in as {{email}}, but you have no position on a vessel. Ask your office to give you access, then try again.",
    "tryAgain": "Try again",
    "signOut": "Sign out",
    "downloadTitle": "First download",
    "downloadBody": "The app downloads the questions of {{vessel}} once. Keep the app open and stay connected to the internet. After this it works without internet.",
    "downloadProgress": "Downloaded: {{count}} records",
    "downloading": "Downloading…",
    "noAccess": "You have no access to this vessel any more. Ask your office."
  },
  "errors": {
    "offline": "No internet. This needs internet. Try again when you have Wi-Fi.",
    "not_configured": "This version of the app is not connected to the Opti-Sea server. Tell your office.",
    "invalid_code": "The code is wrong or too old. Check it, or ask for a new code.",
    "not_invited": "There is no Opti-Sea account for this email address. Ask your office to invite you.",
    "rate_limited": "Too many tries. Wait a few minutes and try again.",
    "invalid_password": "Wrong email address or password.",
    "not_signed_in": "You are signed out on the server. Sign in again.",
    "not_allowed": "You are not allowed to do this.",
    "admin_account": "An Admin account cannot be deleted in the app. Ask the Opti-Sea support.",
    "server": "Something went wrong on the server. Try again later. If it happens again, tell your office."
  },
  "crew": {
    "title": "Crew on board",
    "body": "Who holds each position on {{vessel}}. Open a person to end their access, for example after sign-off.",
    "nobody": "Nobody",
    "since": "{{name}}, since {{date}}",
    "you": "{{name}} (you), since {{date}}",
    "personBody": "{{name}} is {{position}} on {{vessel}} since {{date}}.",
    "endAccess": "End access",
    "ownAccess": "This is you. Only the office can end your access.",
    "endTitle": "End the access of {{name}}?",
    "endBody": "{{name}} ({{position}}) can no longer see or change the questions of {{vessel}}. The work stays with the vessel. The office sees who ended the access and when.",
    "reasonLabel": "Reason (optional)",
    "reasonHint": "For example: signed off",
    "ended": "Access ended",
    "sent": "Sent to the server.",
    "waiting": "Saved on phone. It is sent to the server when there is internet.",
    "rejected": "The server did not accept it. The access may have ended already."
  },
  "accessEnded": {
    "title": "Access ended",
    "body": "Your access to {{vessel}} has ended. If this is a mistake, ask your office.",
    "unsent_one": "{{count}} change on this phone was not sent.",
    "unsent_other": "{{count}} changes on this phone were not sent.",
    "unsentHint": "Opti-Sea sends them by itself when there is internet: work you did before the end of your access is still accepted for 14 days. If you remove the data now, what was not sent is lost.",
    "remove": "Remove the data and sign out",
    "confirmTitle": "Remove the data of {{vessel}}?",
    "confirmBody": "All questions and changes of this vessel are removed from this phone and you are signed out.",
    "unsentPhotos_one": "{{count}} photo on this phone was not sent.",
    "unsentPhotos_other": "{{count}} photos on this phone were not sent.",
    "allSent": "Everything you did on this phone was sent to the office."
  },
  "updateRequired": {
    "title": "Update required",
    "body": "This version of Opti-Sea ({{version}}) is too old. Install version {{minimum}} or newer to continue. Your saved work stays on the phone.",
    "open": "Open the store",
    "noLink": "Your office will send you the link to the new version."
  },
  "photos": {
    "title": "Photos",
    "ofQuestion": "Question {{code}}",
    "add": "Add photo",
    "empty": "No photos for this question yet.",
    "count_one": "{{count}} photo",
    "count_other": "{{count}} photos",
    "onlyLook": "This question is not in your work: you can see its photos but not add new ones.",
    "private": "Photos stay inside Opti-Sea. They are never saved to the phone's photo library.",
    "waiting": "Waiting to be sent",
    "sent": "Sent to the office",
    "taken": "Taken {{time}}",
    "by": "By {{name}}, {{position}}",
    "byNoPosition": "By {{name}}",
    "imageLabel": "Photo of question {{code}}, taken {{time}}",
    "notOnPhone": "The photo is not on this phone.",
    "size": "{{size}} MB, {{width}} × {{height}} pixels",
    "stampWhat": "{{vessel}} · RISQ {{code}}",
    "stampWhen": "{{date}} {{time}} LT ({{offset}})",
    "photoTitle": "Photo",
    "remove": "Remove photo",
    "removeTitle": "Remove this photo?",
    "removeUnsent": "The photo was not sent yet. It is deleted from this phone and nobody will see it.",
    "removeSent": "The photo is removed for everyone. The question history keeps a line that you removed it.",
    "removed": "Photo removed",
    "notFound": "Photo not found",
    "notFoundBody": "This photo is not on your phone any more. Go back to the list.",
    "fullSize": "Show full size ({{size}} MB)",
    "fullSizeLoading": "Downloading the photo…",
    "fullSizeFailed": "The photo could not be downloaded. Internet is needed; try again later.",
    "smallCopy": "This is a small copy. The full photo is on the server."
  },
  "camera": {
    "systemPermission": "Opti-Sea uses the camera to take evidence photos for RISQ questions. The photos stay inside the app and are never saved to your photo library.",
    "permissionTitle": "Camera",
    "permissionBody": "Opti-Sea needs the camera to take evidence photos for the questions. The photos stay inside the app: they are never saved to your photo library, and the app never looks at your other photos.",
    "checking": "Checking camera access…",
    "allow": "Allow camera",
    "deniedBody": "The camera is switched off for Opti-Sea. Open the phone settings, find Opti-Sea and switch the camera on. Then come back here.",
    "openSettings": "Open phone settings",
    "title": "Take photo",
    "forQuestion": "Question {{code}}",
    "view": "Camera picture",
    "take": "Take photo",
    "lightOn": "Light on",
    "lightOff": "Light off",
    "lightIsOn": "The light is on.",
    "ultraWideOn": "0.5x — wide view for tight spaces",
    "ultraWideOff": "1x — normal view",
    "ultraWideIsOn": "Wide view 0.5x is on.",
    "starting": "Starting the camera…",
    "preparing": "Preparing the photo…",
    "checkTitle": "Check photo",
    "use": "Use photo",
    "retake": "Retake",
    "saving": "Saving the photo…",
    "takeFailed": "The photo was not taken. Try again.",
    "saveFailed": "The photo was not saved. Try again.",
    "startFailed": "The camera did not start. Close the app and open it again.",
    "checkDate": "Check the date on your phone"
  },
  "syncDetails": {
    "title": "Sync details",
    "syncNow": "Sync now",
    "syncing": "Syncing…",
    "lastSync": "Last sync: {{time}}",
    "neverSynced": "Not synced yet.",
    "wifiOnly": "Sync uses Wi-Fi only. You can allow mobile data in Settings.",
    "mobileDataAllowed": "Sync uses Wi-Fi and mobile data (Settings).",
    "outcomeOffline": "The last try found no internet. Opti-Sea tries again by itself. Your work is saved on the phone.",
    "outcomeWaitingForWifi": "Waiting for Wi-Fi: mobile data is not used for sync.",
    "outcomeError": "The last sync had a problem. Opti-Sea tries again by itself. If this stays, tell your office.",
    "changes_one": "{{count}} change waiting to be sent",
    "changes_other": "{{count}} changes waiting to be sent",
    "noChanges": "No changes waiting to be sent",
    "photos_one": "{{count}} photo waiting to be sent ({{size}} MB)",
    "photos_other": "{{count}} photos waiting to be sent ({{size}} MB)",
    "noPhotos": "No photos waiting to be sent",
    "storageTitle": "Photos on this phone",
    "storage_one": "{{count}} file, {{size}} MB",
    "storage_other": "{{count}} files, {{size}} MB",
    "storageHint": "Kept in the app's private folder, not in the photo library.",
    "orphans_one": "{{count}} photo file without a record ({{size}} MB)",
    "orphans_other": "{{count}} photo files without a record ({{size}} MB)",
    "orphansBody": "Probably the app was closed while a photo was being saved. The files stay on the phone. Tell your office if this happens again.",
    "missing_one": "{{count}} photo with a missing file",
    "missing_other": "{{count}} photos with a missing file",
    "missingBody": "These photos cannot be sent. Take them again if they are still needed.",
    "missingItem": "Question {{code}}, taken {{time}}",
    "missingUnknown": "Unknown question",
    "stuck_one": "{{count}} change could not be sent several times. Opti-Sea keeps it and tries again.",
    "stuck_other": "{{count}} changes could not be sent several times. Opti-Sea keeps them and tries again.",
    "refusedTitle": "Changes the server did not accept",
    "refusedHint": "They were removed from the phone. If something is missing, do it again or ask your office.",
    "refusedLine": "{{what}}, made {{time}}: {{why}}",
    "what": {
      "risq_set_status": "Status of question {{code}}",
      "risq_add_note": "Note on question {{code}}",
      "risq_set_wtc_check": "Check mark on question {{code}}",
      "risq_set_question_positions": "Responsible position of question {{code}}",
      "risq_revert_question_positions": "Responsible position of question {{code}}",
      "risq_set_inspection_date": "Inspection date",
      "risq_set_last_voyage": "Start of the last voyage",
      "risq_set_final_check": "Final checks mark",
      "risq_add_evidence": "Photo of question {{code}}",
      "risq_remove_evidence": "Removal of a photo of question {{code}}",
      "core_revoke_assignment": "End of access of a crew member",
      "other": "A change"
    },
    "why": {
      "access_ended": "your access to the vessel had ended",
      "not_allowed": "your position may not do this",
      "invalid": "the server could not use it",
      "not_found": "it does not exist on the server any more",
      "unknown_type": "the server does not know this change yet",
      "other": "the server did not accept it"
    },
    "logShow": "Show the sync log (for support)",
    "logHide": "Hide the sync log",
    "logTitle": "Sync log",
    "logEmpty": "Nothing in the log yet.",
    "logLine": "{{time}} {{message}}"
  },
  "signInAgain": {
    "title": "Sign in again",
    "body": "The server does not know your sign-in any more (for example, you signed out on another device). Your work stays on this phone and is sent after you sign in again.",
    "button": "Sign in again",
    "emailBody": "Your work stays on this phone. We send a 6-digit code to your email address.",
    "otherAccount": "This is another account. This phone keeps the work of the person who signed in first: sign in with that email address.",
    "done": "Signed in again",
    "doneBody": "Your work on this phone was kept. It is sent to the office now."
  }
}
